import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { colors } from 'src/theme'
import { breadcrumbTransformer } from 'src/models/Breadcrumb/breadcrumbTransformer'
import { tagCommanderTransformer } from 'src/models/TagCommander/tagCommanderTransformer'
import { TcPageTemplateNames } from 'src/configuration/tagcommander'

import { selectors } from '../redux'
import { onboardingCoverTransformer } from '../models/Onboarding'
import { generatingSectionTransformer } from '../models/GeneratingPlanning'

const useGeneratingPlanning = () => {
  const { t } = useTranslation()
  const generationMessage = useSelector(selectors.user.generationMessage)
  const breadcrumbConfig = breadcrumbTransformer({
    bgColor: colors.greenMint,
    t,
    lastItems: [],
  })
  const generatingPlanningProps = useMemo(
    () => ({
      coverSectionProps: onboardingCoverTransformer(t, breadcrumbConfig),
      generatingSectionProps: generatingSectionTransformer(
        t,
        generationMessage ?? ''
      ),
      mobileBreadcrumbProps: breadcrumbConfig,
      tcProps: tagCommanderTransformer({
        pageName: t('tracking_page_chapter_3'),
        tcTemplate: TcPageTemplateNames.Another,
        tcCAt1: t('tracking_page_chapter_1'),
        tcCAt2: t('tracking_page_chapter_2'),
        tcCAt3: t('tracking_page_chapter_3'),
      }),
    }),
    [t, breadcrumbConfig, generationMessage]
  )
  return { generatingPlanningProps }
}

export default useGeneratingPlanning
